import { ButtonLink } from "@kds-web/button";
import { CircleCheckmarkFillIcon, DismissIcon } from "@kds-web/icons";
import * as cookie from "cookie-es";
import { useState } from "react";
import type { JSX } from "react/jsx-runtime";
import {
  COOKIE_LOGIN_OVERLAY,
  COOKIE_LOGIN_OVERLAY_MAX_AGE,
} from "../../constants";

export interface Props {
  loginUrl: string;
  registerUrl: string;
  showLoginOverlay: boolean;
}

const LOGIN_BENEFITS = [
  "Nachrichten senden und empfangen kannst",
  "Eigene Anzeigen aufgeben kannst",
  "Für dich interessante Anzeigen siehst",
];

function LoginOverlay({
  loginUrl,
  registerUrl,
  showLoginOverlay,
}: Props): JSX.Element | null {
  const [showOverlay, setShowOverlay] = useState(showLoginOverlay);

  if (!showOverlay) {
    return null;
  }

  function closeOverlay(): void {
    setShowOverlay(false);
    const cookieString = cookie.serialize(COOKIE_LOGIN_OVERLAY, "seen", {
      maxAge: COOKIE_LOGIN_OVERLAY_MAX_AGE,
      path: "/",
    });
    document.cookie = cookieString;
  }

  return (
    <div className="absolute top-[69px] z-raised w-min bg-surface p-medium shadow-elevation before:absolute before:-top-xsmall before:left-[12.2rem] before:size-medium before:rotate-45 before:border-x-8 before:border-surface before:bg-surface">
      <h2 className="text-title3 text-secondary">Hallo!</h2>
      <p className="mb-large mt-medium">
        Willkommen bei Kleinanzeigen. Melde dich hier an, oder erstelle ein
        neues Konto, damit du:
      </p>
      <button
        type="button"
        className="absolute right-xsmall top-xsmall p-xxsmall"
        aria-label="Willkommens-Popup Schließen"
        onClick={closeOverlay}
      >
        <DismissIcon />
      </button>
      <ul>
        {LOGIN_BENEFITS.map((benefit) => (
          <li key={benefit} className="mb-xsmall flex items-center gap-small">
            <CircleCheckmarkFillIcon className="text-secondary" size="large" />
            <p className="whitespace-nowrap text-bodySmall font-regular">
              {benefit}
            </p>
          </li>
        ))}
      </ul>
      <ul className="mt-large flex justify-end gap-xsmall">
        <li>
          {/* TODO: add tracking */}
          <ButtonLink
            href={registerUrl}
            label="Registrieren"
            variant="secondary"
            onClick={closeOverlay}
          />
        </li>
        <li>
          {/* TODO: add tracking */}
          <ButtonLink
            href={loginUrl}
            label="Einloggen"
            variant="primary"
            onClick={closeOverlay}
          />
        </li>
      </ul>
    </div>
  );
}

export default LoginOverlay;
